enum BetBuilderMessageDataCommand {
	ADD_TO_BETSLIP = 'addToBetslip'
}

export type BetBuilderMessageData = {
	command: BetBuilderMessageDataCommand;
};

export type BetBuilderAddToBetslipMessageData = BetBuilderMessageData & {
	command: BetBuilderMessageDataCommand.ADD_TO_BETSLIP;
	betslipUid: string;
};

export const isAddToBetslipMessageData = (data: object): data is BetBuilderAddToBetslipMessageData =>
	'command' in data && data.command === BetBuilderMessageDataCommand.ADD_TO_BETSLIP;
